import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/enterprise-division"

class service {

    selectList(enterpriseId) {

        let params = new URLSearchParams()
        params.append("enterpriseId", enterpriseId)

        return http.list(path + "/selectList",params);
    }

}

export default new service();

